import React from "react";

const DefaultAttributeEditor = ({ modal, setModal }) => {
    // Handles when an attribute value is selected from the dropdown
    const handleSelectChange = (key, selectedValue) => {
        setModal((prevModal) => ({
            ...prevModal,
            data: {
                ...prevModal.data,
                [key]: {
                    ...prevModal.data[key],
                    selected: selectedValue,
                },
            },
        }));
    };

    return (
        <div className="attribute-editor">
            <table className="attribute-editor-table">
                <thead>
                    <tr>
                        <th>Attribute Name</th>
                        <th>Values</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(modal.data).map(([key, attribute], index) => (
                        <tr key={index}>
                            <td>
                                <strong>{attribute.label}</strong>
                            </td>
                            <td>
                                {attribute.istax === "yes" && Array.isArray(attribute.values) ? (
                                    <select
                                        value={attribute.selected || ""}
                                        onChange={(e) => handleSelectChange(key, e.target.value)}
                                    >
                                        <option value="">Select a value</option>
                                        {attribute.values.map((value, valueIndex) => (
                                            <option key={valueIndex} value={value.slug}>
                                                {value.name}
                                            </option>
                                        ))}
                                    </select>
                                ) : attribute.istax === "no" && Array.isArray(attribute.values) ? (
                                    <select
                                        value={attribute.selected || ""}
                                        onChange={(e) => handleSelectChange(key, e.target.value)}
                                    >
                                        <option value="">Select a value</option>
                                        {attribute.values.map((value, valueIndex) => (
                                            <option key={valueIndex} value={value}>
                                                {value}
                                            </option>
                                        ))}
                                    </select>
                                ) : (
                                    <p>No values available</p>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DefaultAttributeEditor;
